module.exports = __webpack_public_path__ + "img/mfhqfa.ef0a5d12.jpg";